import React from "react";
import ErrorImage from "@/images/error-file.svg";
import { FormattedMessage } from "react-intl";
import { Button } from "antd";
import Template from "@/files/people_template_v.2022.1.xls";

function UploadError({ onOk }) {
  return (
    <div
      style={{
        textAlign: "center",
        marginTop: "12%",
      }}
    >
      <img src={ErrorImage} alt="Error" style={{ marginBottom: "1rem" }} />
      <p style={{ color: "#CD1717", fontSize: "0.8rem" }}>
        <FormattedMessage
          id="App.ImportFromFile.Failed1"
          defaultMessage="Sorry, We could not import your file."
        />
      </p>
      <p
        style={{
          color: "#707070",
          fontSize: "0.8rem",
          maxWidth: "500px",
          margin: "auto",
        }}
      >
        You may be using an old template. Download the template below and follow
        the instructions on how to fill in your data. Then, try to import the
        file again. Make sure Email or Phone Number is defined for each person.
      </p>
      <div>
        <Button className="downloadButton">
          <a download href={Template} style={{ fontSize: "0.8rem" }}>
            <FormattedMessage
              id="App.Button.DownloadTemplate"
              defaultMessage={"Download template"}
            />
          </a>
        </Button>
      </div>
      <div>
        <Button
          style={{ color: "#05538C", fontSize: "0.8rem" }}
          type="link"
          onClick={onOk}
        >
          <FormattedMessage
            id="App.Text.TryImport"
            defaultMessage={"Try import again"}
          />
        </Button>
      </div>
    </div>
  );
}

export default UploadError;
